import { workFlowConstants } from '../constants'
import { workFlowRequests } from '../../services'

export const workFlowActions = {}

workFlowActions.GetBinnacleInfo = (data) => {
  return dispatch => {
    dispatch(request())
    workFlowRequests.GetBinnacleInfo(data)
      .then(
        binnacleInfo => dispatch(success(binnacleInfo)),
        error => dispatch(failure(error.message))
      )
  }

  function request() {
    return { type: workFlowConstants.WF_BINNACLE_REQUEST }
  }

  function success(binnacleInfo) {
    return { type: workFlowConstants.WF_BINNACLE_SUCCESS, binnacleInfo }
  }

  function failure(error) {
    return { type: workFlowConstants.WF_BINNACLE_FAILURE, error }
  }
}

workFlowActions.ContinueWorkFlow = (data) => {
  return dispatch => {
    dispatch(request())
    workFlowRequests.ContinueWorkFlow(data)
      .then(
        contineWFData => dispatch(success(contineWFData)),
        error => dispatch(failure(error.message))
      )
  }

  function request() {
    return { type: workFlowConstants.CONTINUE_WF_REQUEST }
  }

  function success(contineWFData) {
    return { type: workFlowConstants.CONTINUE_WF_SUCCESS, contineWFData }
  }

  function failure(error) {
    return { type: workFlowConstants.CONTINUE_WF_FAILURE, error }
  }
}